module.exports = __webpack_public_path__ + "static/media/logo.c967168a.svg";